import { combineReducers } from 'redux';
import surveyReducer from './surveyReducer';
import autoSaveReducer from './autoSaveReducer';
import timerReducer from './timerReducer';
import pageReducer from './pageReducer';
import respondentNameReducer from './respondentNameReducer';
import surveyOptionsReducer from './surveyOptionsReducer';
import preliminaryOptionsReducer from './preliminaryQuestionsReducer';
import logoReducer from './logoReducer';
import changeLanguageReducer from './changeLanguageReducer';

const rootReducer = combineReducers({
    autoSaveReducer,
    pageReducer,
    respondentNameReducer,
    surveyReducer,
    timerReducer,
    surveyOptionsReducer,
    preliminaryOptionsReducer,
    logoReducer,
    changeLanguageReducer
});

export default rootReducer;
